/* eslint-disable no-unused-vars */
export enum WalletType {
	all = -1,
	ordinary = 0, //Обычный (лімітний)
	transit = 1, //Транзитный
	individual = 2, //Индивидуальный
	blockedResources = 3, // Blocked resources
}

export enum FindCustomerCardSearchType {
	info = 'info',
	telephone = 'telephone',
	cardnumber = 'cardnumber',
}

export enum AccountStateType {
	all = -1,
	active = 0,
	inactive = 1,
}

export enum InteractionType {
	donor = 0,
	hasDonor = 1,
	regular = 2,
}

export enum CardsCommonAction {
	transferCardToCard = 'transferCardToCard',
	transferCardToWallet = 'transferCardToWallet',
	transferWalletToCard = 'transferWalletToCard',
	virtualBalance = 'virtualBalance',
	allowApp = 'allowApp',
	cardStatus = 'cardStatus',
	info = 'info',
	periods = 'periods',
	services = 'services',
	transfer = 'transfer',
	limits = 'limits',
	resetPin = 'resetPin',
	resetCard = 'resetCard',
	terminals = 'terminals',
	individualBalance = 'individualBalance',
	automaticBlocking = 'automaticBlocking',
	generatePin = 'generatePin',
}

export enum CardStatus {
	inStock = 0, //На складі
	notActive = 1, //Не активна
	active = 2, //Активна
	blocked = 3, //Заблокирована
	closed = 4, //Закрита
}

export enum CardState {
	inStock = 'inStock',
	notActive = 'notActive',
	active = 'active',
	disable = 'disable',
	closed = 'closed',
	blocked = 'blocked',
}

export enum optionsToChoose {
	allow = 'allow',
	forbid = 'forbid',
}

export enum reports {
	customerInfo = 'customerInfo',
	contractorTransactions = 'contractorTransactions',
	individualBalancesWallets = 'individualBalancesWallets',
	individualBalancesCards = 'individualBalancesCards',
	gasStations = 'gasStations',
	prideCardBindings = 'prideCardBindings',
	limitsOfCard = 'limitsOfCard',
	converterSimplified = 'converterSimplified',
	converter = 'converter',
	sheetLiterWallets = 'sheetLiterWallets',
	sheet = 'sheet',
	transactionsExport = 'transactionsExport',
	transactions = 'transactions',
	remains = 'remains',
	movingBetweenWalletsAndCards = 'movingBetweenWalletsAndCards',
	turnovers = 'turnovers',
	issuerconverter = 'issuerconverter',
	issuertransactions = 'issuertransactions',
}

export enum paymentCardsAction {
	GETCARDS = 'GETCARDS',
	SAVECARD = 'SAVECARD',
	CHANGECARDNAME = 'CHANGECARDNAME',
	DELETECARD = 'DELETECARD',
}

export enum scheduledJobWithCardType {
	change = 'CHANGESTATUS_CHANGEVALUES',
	current = 'CHANGESTATUS_CURRENTVALUES',
	delete = 'CHANGESTATUS_DELETEVALUES',
}
